import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Receipt,
  FileText,
  Tag,
  ArrowRight,
} from "lucide-react";

const TYPE_COLORS = {
  DEFAULT: "bg-blue-100 text-blue-700 border-blue-300",
  FIXED: "bg-purple-100 text-purple-700 border-purple-300",
};

const TYPE_ICONS = {
  DEFAULT: Receipt,
  FIXED: Tag,
};

export function PaymentCard(props) {
  const { name, invoiceId, type = "DEFAULT", editClick } = props;
  
  const TypeIcon = TYPE_ICONS[type] || Receipt;

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 hover:border-primary/50 overflow-hidden">
      {/* Header with gradient accent */}
      <div className="h-2 bg-gradient-to-r from-green-500 via-emerald-500 to-teal-500" />

      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <CardTitle className="text-xl mb-1 group-hover:text-primary transition-colors flex items-center gap-2">
              <Receipt className="h-5 w-5" />
              {name}
            </CardTitle>
            <CardDescription className="flex items-center gap-1.5 text-sm">
              <FileText className="h-3.5 w-3.5" />
              {invoiceId}
            </CardDescription>
          </div>
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        {/* Type Badge */}
        <div className="flex items-center gap-2 p-3 rounded-lg bg-gradient-to-br from-gray-50 to-slate-50 dark:from-gray-900/50 dark:to-slate-900/50 border">
          <div className={cn(
            "h-10 w-10 rounded-full flex items-center justify-center flex-shrink-0",
            TYPE_COLORS[type] || TYPE_COLORS.DEFAULT
          )}>
            <TypeIcon className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Ödeme Tipi</p>
            <Badge 
              variant="outline" 
              className={cn("mt-1", TYPE_COLORS[type] || TYPE_COLORS.DEFAULT)}
            >
              {type}
            </Badge>
          </div>
        </div>

        {/* Invoice Info */}
        <div className="p-3 rounded-lg bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-950/30 dark:to-indigo-950/30 border border-blue-200 dark:border-blue-800">
          <div className="flex items-center gap-2 mb-1">
            <FileText className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            <span className="text-xs font-semibold text-blue-700 dark:text-blue-400 uppercase tracking-wide">
              Fatura Detayları
            </span>
          </div>
          <p className="text-sm font-medium text-foreground">
            {invoiceId}
          </p>
        </div>
      </CardContent>

      <CardFooter className="pt-4 border-t bg-muted/20">
        <Button
          onClick={editClick}
          className="w-full group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
          variant="outline"
        >
          Detayları Gör
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </CardFooter>
    </Card>
  );
}
